import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import HomePage from "./pages/HomePage";
import PropertyDetail from "./pages/PropertyDetail";
import ClaimListing from "./pages/ClaimListing";
import ClaimWithToken from "./pages/ClaimWithToken";
import OwnerDashboard from "./pages/OwnerDashboard";
import AdminPanel from "./pages/AdminPanel";
import EditListing from "./pages/EditListing";
import CreditApplicationPage from "./pages/CreditApplicationPage";
import AuthPage from "./pages/AuthPage";
import BlogPage from "./pages/blog/BlogPage";
import BlogArticle from "./pages/blog/BlogArticle";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-stone-100">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/claim/:token" element={<ClaimWithToken />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            
            {/* Public property detail page */}
            <Route path="/proprietate/:id" element={<PropertyDetail />} />
            
            {/* Protected routes - require authentication */}
            <Route path="/revendica/:id" element={
              <ProtectedRoute>
                <ClaimListing />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <OwnerDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/edit/:id" element={
              <ProtectedRoute>
                <EditListing />
              </ProtectedRoute>
            } />
            <Route path="/aplica-credit/:id" element={
              <ProtectedRoute>
                <CreditApplicationPage />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
